<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="任务名称" prop="scheduleName">
        <el-input v-model.trim="queryParams.scheduleName" placeholder="请输入任务名称" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="任务执行标识" prop="taskName">
        <el-select-dict dictType="SCHEDULE_TASK" @dictChange="handleQuery" v-model="queryParams.taskName" clearable
          placeholder="请选择任务执行标识" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="status">
        <el-select-dict dictType="STATUS" clearable placeholder="请选择状态" v-model="queryParams.status"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['monitor:schedule:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['monitor:schedule:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['monitor:schedule:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>

        <el-button v-hasPermission="['log:schedule:list']" type="success" class="fr" size="mini"
          @click="$router.push({ name: 'logScheduleManage' })">任务日志</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="scheduleTable" instanceHeight="238" :class="{ 'empty': list.length === 0 }"
          empty-text=" " v-loading="loading" :data="list" row-key="scheduleId" @selection-change="handleSelectionChange"
          @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column label="任务名称" prop="scheduleName" align="center" min-width="139px" />
          <el-table-column-dict dictType="SCHEDULE_TASK" label="任务标识" align="center" prop="taskName"
            min-width="200px"></el-table-column-dict>
          <el-table-column-dict dictTypeNode="tag" label="cron执行表达式" align="center" prop="cron"
            min-width="139px"></el-table-column-dict>
          <el-table-column-dict dictType="STATUS" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column v-if="
            mixinHasPermi([
              'monitor:schedule:status',
              'monitor:schedule:read',
              'monitor:schedule:delete',
            ])
          " label="操作" align="center" width="256px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['monitor:schedule:status']" size="mini"
                :type="scope.row.status === '1' ? 'warning' : 'success'"
                @click.native.stop="handleStatusChange(scope.row)">{{ scope.row.status === "1" ? "停用" : "启用"
                }}</el-button>
              <el-button v-hasPermission="['monitor:schedule:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button v-hasPermission="['monitor:schedule:delete']" size="mini" type="danger" icon="el-icon-delete"
                @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>
      </div>
    </div>
    <schedule-dialog ref="scheduleDialog" :visible.sync="open" :modal-append-to-body="false"
      :close-on-click-modal="false" :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="getList"
      width="1024px"></schedule-dialog>
  </div>
</template>

<script>
import ScheduleDialog from "./components/schedule-dialog.vue"
import { scheduleApi } from "@/api"
export default {
  name: "monitorScheduleManage",
  components: {
    ScheduleDialog
  },
  data() {
    return {
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        scheduleName: "", // 任务名称
        taskName: "", // 执行任务标识
        status: "" // 定时任务状态
      },
      list: [],
      selection: [], //选中的项
      loading: false,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        scheduleName: "", // 任务名称
        taskName: "", // 执行任务标识
        cron: "", // cron执行表达式
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          scheduleName: "", // 任务名称
          taskName: "", // 执行任务标识
          cron: "", // cron执行表达式
          remark: "" // 备注
        }
        this.$refs.scheduleDialog && this.$refs.scheduleDialog.resetForm()
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    //点击行
    clickRow(row) {
      this.$refs.scheduleTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.scheduleId)
        str += item.scheduleName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认删除任务名称为"【' + str + '】"的数据项？')
        .then(function() {
          return scheduleApi.batchDeleteSchedule({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除定时任务成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.scheduleTable.clearSelection()
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      scheduleApi
        .getScheduleList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.scheduleId) {
        this.isUpdate = true
      }
      const scheduleId =
        row.scheduleId || (this.selection[0] && this.selection[0].scheduleId)
      scheduleApi.getJobInfo({ scheduleId }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.mixinBtnBlur()
      const scheduleName = row.scheduleName
      this.$modal
        .confirm('是否确认删除定时任务名称为"' + scheduleName + '"的数据项？')
        .then(function() {
          return scheduleApi.deleteSchedule({ scheduleId: row.scheduleId })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("删除成功")
        })
    },

    // 状态改变事件
    handleStatusChange(row) {
      if (row.status === "1") {
        scheduleApi.stopSchedule({ scheduleId: row.scheduleId }).then((data) => {
          this.$modal.msgSuccess(`定时任务${row.scheduleName}停用成功`)
          this.getList()
        })
      } else {
        scheduleApi.startSchedule({ scheduleId: row.scheduleId }).then((data) => {
          this.$modal.msgSuccess(`定时任务${row.scheduleName}启用成功`)
          this.getList()
        })
      }
    }
  }
}
</script>